import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-polizas',
  templateUrl: './polizas.component.html',
  styleUrls: ['./polizas.component.scss']
})

export class PolizasComponent implements OnInit  {
  constructor() {}

  ngOnInit(): void {
  }
}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/polizas/polizas.component.ts